(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-month-early-access"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bm-countdown')) {
    customElements.define(
      'bm-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.target = Date.parse(this.dataset.deadline);
          this.d = this.querySelector('[data-d]');
          this.h = this.querySelector('[data-h]');
          this.m = this.querySelector('[data-m]');
          this.s = this.querySelector('[data-s]');
          this.cta = this.querySelector('[data-cta]');
          this.openLabel = this.querySelector('[data-label-open]');
          this.closedLabel = this.querySelector('[data-label-closed]');
          this.section = this.closest('.bm-ea');
          if (this.cta) this.cta.addEventListener('click', (e) => this.scrollToNext(e));
          if (Number.isNaN(this.target)) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        nextSection() {
          let node = this.section.closest('.shopify-section') || this.section;
          node = node.nextElementSibling;
          while (node && (node.offsetHeight === 0 || node.matches('script, style, link'))) node = node.nextElementSibling;
          return node;
        }
        scrollToNext(e) {
          const target = this.nextSection();
          if (!target) return;
          e.preventDefault();
          const header = document.querySelector('.talaria-header');
          const offset = header ? header.offsetHeight : 0;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
          const field = target.querySelector('input:not([type="hidden"]), select, textarea');
          if (field) setTimeout(() => field.focus({ preventScroll: true }), reduce ? 0 : 700);
        }
        pad(n) {
          return String(n).padStart(2, '0');
        }
        tick() {
          const diff = this.target - Date.now();
          if (diff <= 0) {
            clearInterval(this.timer);
            [this.d, this.h, this.m, this.s].forEach((el) => el && (el.textContent = '00'));
            if (this.openLabel) this.openLabel.hidden = true;
            if (this.closedLabel) this.closedLabel.hidden = false;
            if (this.cta) {
              this.cta.removeAttribute('href');
              this.cta.setAttribute('aria-disabled', 'true');
            }
            if (this.section) this.section.classList.add('is-closed');
            return;
          }
          const total = Math.floor(diff / 1000);
          this.d.textContent = this.pad(Math.floor(total / 86400));
          this.h.textContent = this.pad(Math.floor((total % 86400) / 3600));
          this.m.textContent = this.pad(Math.floor((total % 3600) / 60));
          this.s.textContent = this.pad(total % 60);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
